import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {DashboardComponent} from './dashboard.component';
import {SharedModule} from "../../shared/shared.module";
import {ChartModule} from "primeng/chart";
import {DatePipe} from "@angular/common";

@NgModule({
  declarations: [DashboardComponent],
    imports: [
        SharedModule,
        ChartModule
    ],
  exports: [DashboardComponent],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule {

}
